import { render, staticRenderFns } from "./award-message.vue?vue&type=template&id=90cd009a&scoped=true"
import script from "./award-message.vue?vue&type=script&lang=js"
export * from "./award-message.vue?vue&type=script&lang=js"
import style0 from "./award-message.vue?vue&type=style&index=0&id=90cd009a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cd009a",
  null
  
)

export default component.exports